import FIKA from "assets/images/icons/fika-icon.svg";
import TRENT from "assets/images/icons/trent-icon.svg";
import GENERICO from "assets/images/icons/generico-icon.svg";
import SINASIGNAR from "assets/images/icons/sinAsignar-icon.svg";
import FEMMTO from "assets/images/icons/femmto-icon.svg";
import MeliIcon from "assets/images/icons/meli-icon.svg";
import VtexIcon from "assets/images/icons/vtex-icon.svg";
import AmazonIcon from "assets/images/icons/amazon-icon.svg";
import B2bIcon from "assets/images/icons/b2b-icon.svg";

export const COLUMNS = [
  { data: "inventory", label: "Inventario" },
  { data: "formerMonth", label: "Mes anterior" },
  { data: "formerDaily", label: "Ventas diarias" },
  { data: "formerTotal", label: "Totales mensuales" },
  { data: "currentMonth", label: "Mes actual" },
  { data: "currentDaily", label: "Ventas diarias" },
  { data: "currentTotal", label: "Totales mensuales" },
];

export const ROWS = [
  { data: "target", label: "Target" },
  { data: "tsu", label: "TSU" },
  { data: "GMV", label: "GMV" },
  { data: "ASP", label: "ASP $" },
  { data: "mg", label: "MG%" },
  { data: "roas", label: "ROAS" },
  { data: "mc2", label: "%MC2" },
  { data: "ux", label: "UX (MELI)" },
  { data: "visits", label: "Visitas" },
  { data: "CVR", label: "CVR (Conversion rate)" },
  { data: "stock", label: "Stock" },
];

export const LIFE_CYCLES = [
  { key: "npi", label: "NPI" },
  { key: "ini", label: "INI" },
  { key: "maturity", label: "Maturity" },
  { key: "exit", label: "Exit" },
];

export function getDayFieldVisibility({ month, show }) {
  const ids = {};

  for (let i = 1; i <= 31; i++) {
    ids[`${month}-${i}`] = show;
  }

  return ids;
}

export function getInventoryFieldVisibility({ show }) {
  return {
    fulfillment: show,
    days: show,
    stock: show,
    velocidad_rotacion: show,
    dias_stock: show,
  };
}

export function getSpecialFieldVisibility({ month, show }) {
  return {
    [`${month}-acc`]: show,
    [`${month}-forecast`]: show,
    [`${month}-proyectado`]: show,
    [`${month}-gap`]: show,
  };
}

export const monthNames = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

export const brandIcons = {
  FIKA: FIKA,
  TRENT: TRENT,
  GENERICO: GENERICO,
  "SIN ASIGNAR": SINASIGNAR,
  FEMMTO: FEMMTO,
};

export const MarketplaceIcons = {
  MELI: MeliIcon,
  VTEX: VtexIcon,
  AMZN: AmazonIcon,
  OFF: B2bIcon,
};
